<template>
    <div>
        <div class="ct-btn-box">
            <button type="button" class="wv-btn wv-btn-primary" v-on:click="generate"> {{ $t('button_generate') }}</button>
        </div>
        <CommonModal v-bind:text="this.modalContent" v-if="showModal" v-on:close="showModal=false"/>
    </div>
</template>

<script>
import _capitalize from "lodash/capitalize";
import CommonModal from '@/components/CommonModal';

export default {
    name: "GenerateButton",
    components: {
        'CommonModal' : CommonModal,
    },
    props: ["citationStyle", "citationSource", "contributorData", "formData"],
    data: function () {
        return {
            result: "",
            showModal: false,
            modalContent : '',

            cite_sources : [
                { text: 'Website', value: 'webpage', class:''},
                { text: 'Journal Article', value: 'article-journal', class:''},
                { text: 'Book', value: 'book', class:''},
            ],
            citation_styles : [
                { text: 'APA 6th', value: 'apa6'},
                { text: 'APA 7th', value: 'apa7'},
                { text: 'MLA 7th', value: 'mla7'},
                { text: 'MLA 8th', value: 'mla8'},
                { text: 'Chicago 17th', value: 'chicago17'},
                { text: 'Vancouver', value: 'vancouver'},
            ],
        }
    },
    methods : {
        async generate() {
            await this.$emit("getFormData")

            let xhr = new XMLHttpRequest();
            let citeprocSys = {
                tmp_path : this.root_path,
                retrieveLocale: function (lang){
                    let locale_path = this.tmp_path+`static/citeproc/locale/locales-${lang}.xml`;
                    xhr.open('GET', locale_path, false);
                    xhr.send(null);
                    return xhr.responseText;
                },

                retrieveItem: function(id) {
                    return window.build_json[id];
                }
            };

            // style 읽어오기
            let path = this.root_path+`static/citeproc/style/${this.citationStyle}.csl`;
            xhr.open('GET', path, false);
            xhr.send(null);
            let style = xhr.responseText;

            let json = this.buildJson();
            window.build_json = json;

            let itemIDs = [];
            for (let key in json) {
                itemIDs.push(key);
            }

            let citeproc = new CSL.Engine(citeprocSys, style);
            citeproc.updateItems(itemIDs);

            let bibResult = citeproc.makeBibliography();
            let bib = bibResult[1].join('\n');

            if(bib.indexOf('CSL STYLE ERROR') > 0) this.result = "To complete your citation I'm going to need you to fill out at least one field.";
            else this.result = bib;

            this.showCommonModal(this.result)

            let cit_source = this.cite_sources[this.GetIndexByValue(this.cite_sources, this.citationSource)].text;
            let cit_style = this.citation_styles[this.GetIndexByValue(this.citation_styles, this.citationStyle)].text;

            // save
            let save = {
                source: cit_source,
                style: cit_style,
                result: this.result.trim(),
            };
            this.$store.commit('save_cite', save);

            // 애널리틱스 전송
            if( typeof gtag === 'function' ) {
                gtag('event', 'Click Generate', {
                    event_category: 'Citation Generator',
                    event_label: `${cit_source} - ${cit_style}`,
                });
                console.log('send event.');
            }

        },

        buildJson: function () { // 입력한 값을 Json화 시켜줌.
            let json = {"Item-1": {id: 'Item-1', type: this.citationSource}};
            if( this.contributorData.length < 0 ) return false;
            let contribAry = [];
            for( let cont of this.contributorData ) {
                if( this.citationStyle === 'apa6' || this.citationStyle === 'apa7' ) { // 첫글자 대문자로 강제 전송
                    cont['middle'] = _capitalize(cont['middle']);
                    cont['given'] = _capitalize(cont['given']);
                    cont['family'] = _capitalize(cont['family']);
                }

                let first = (cont['middle']) ? cont['given']+' '+cont['middle'] : cont['given'];

                if(cont['given'] + cont['middle'] + cont['family'] !== ''){
                    if(contribAry.indexOf(cont['contributor'])){
                        json['Item-1'][cont['contributor']] = [{'given':first, 'family':cont['family']}];
                    } else{
                        json['Item-1'][cont['contributor']].push({'given':first, 'family':cont['family']});
                    }
                    contribAry.push(cont['contributor']);
                }
            }

            // MLA8 에선 URL입력 값에서 https:// 또는 http:// 제거
            if( typeof this.formData.URL !== 'undefined' && this.citation_style === 'mla8' )
                this.formData.URL = this.formData.URL.replace(/(https:\/\/)|(http:\/\/)/g, '');

            // 추가 데이터 가공
            for (const [key, value] of Object.entries(this.formData)) {
                let key_name = key;
                let change_value = value;
                if( key === 'dateParts' ) key_name = 'date-parts';
                if( key === 'page' ) change_value = change_value.replace('-', '–');
                if( key === 'issued2' && typeof value['date-parts'][0][2] !== 'undefined' && value['date-parts'][0][2] ) key_name = 'issued';
                if( typeof value === 'string' ) change_value = change_value.trim(); // TRIM
                json['Item-1'][key_name] = change_value;
            }
            return json;
        },

        showCommonModal (txt){
            //show Modal
            this.showModal = true;
            this.modalContent = txt;
            document.body.classList.add("modal-open");
        },

        GetIndexByValue(arrayName, value) {
            let keyName = "";
            let index = -1;
            for (let i = 0; i < arrayName.length; i++) {
                let obj = arrayName[i];
                for (let key in obj) {
                    if (obj[key] === value) {
                        keyName = key;
                        index = i;
                    }
                }
            }
            return index;
        },
    },

    mounted() {
        if( process.env.NODE_ENV === 'production' ) this.root_path = '/cite-dist/';
        else this.root_path = '/';

        const citeproc_js_url = this.root_path+'static/citeproc/citeproc.min.js';
        let citeprocScript = document.createElement('script');
        citeprocScript.setAttribute('src', citeproc_js_url);
        document.head.appendChild(citeprocScript);
    }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/generator/GenerateButton.vue